import { Print, LocalPrintshopOutlined } from '@mui/icons-material'
import { styled } from '@mui/material'

export const StyledFullPrintIcon = styled(Print)(({ theme }) => ({
   color: 'grayText',
   '&:hover': {
      color: theme.palette.primary.main,
   },
}))

export const StyledClientPrintIcon = styled(LocalPrintshopOutlined)(({ theme }) => ({
   color: 'grayText',
   '&:hover': {
      color: theme.palette.primary.main,
   },
}))
